/* eslint @typescript-eslint/no-var-requires: "off" */

import Vue from "vue";
import dayjs from "dayjs";

const utc = require("dayjs/plugin/utc");
require("dayjs/locale/ja");

dayjs.locale("ja");
dayjs.extend(utc);

Vue.prototype.$dayjs = dayjs;
